<template>
  <div>
    <datatable title="Vetting Recipes" @delete="deleteRecipe" @create="createNewRecipe" @edit_click="editRecipe" :response="data" :fields="fields"></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable'
export default {
  name: 'vetting-recipes',
  data () {
    return {
      data: [],
      fields: [
        {
          name: 'recipe_name',
          value: 'recipe_name'
        }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getVettingRecipes().then(response => {
        this.data = response
      })
    },
    createNewRecipe () {
      this.create({
        desigantor: 'vetting-recipe-modal',
        component_name: 'VettingRecipeForm',
        modal_title: 'Create new Vetting Recipe',
        is_create: true,
        onRecipesUpdated: this.onRecipesUpdated
      })
    },
    onRecipesUpdated (recipes) {
      this.data = recipes
    },
    editRecipe (recipe) {
      this.create({
        desigantor: 'vetting-recipe-modal',
        component_name: 'VettingRecipeForm',
        modal_title: recipe.recipe_name,
        onRecipesUpdated: this.onRecipesUpdated,
        data: recipe
      })
    },
    deleteRecipe (delete_data) {
      this.create({
        designator: 'delete-prompt',
        component_name: 'DeletePrompt',
        modal_title: `Delete ${delete_data.recipe_name}`,
        item_name: delete_data.recipe_name,
        method: 'deleteVettingRecipe',
        method_params: { id: delete_data.id }
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped>
  td {
    padding-top: 30px;
  }
</style>
